import React from 'react';
import { ContractTabProps } from 'routes/Contracts/ContractDetail/navigation-tab/contract-config-tabs';
import ContractDetail from 'components/features/binding/contract-detail';

const Underwriting: React.FC<ContractTabProps> = ({ contract }) => {
  return (
    contract?.submission &&
    contract?.contractId && (
      <div className="rounded-lg bg-[#E3F2FB]">
        <div className="rounded-lg px-2 bg-white py-4 space-y-4">
          <h1 className="text-2xl font-semibold px-2">Contract Details</h1>
          <ContractDetail
            submission={contract?.submission}
            handleBackToBindingDashboard={() => {}} // empty function since we don't need navigation here
            contractId={contract?.contractId}
            disabled={true}
            hideAllActions={true}
            enableFileUpload
          />
        </div>
      </div>
    )
  );
};

export default Underwriting;
